import { Component, OnInit } from '@angular/core';
import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';

import { Store, select } from '@ngrx/store';
import { FacilityAssetDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-facilityasset-container',
  templateUrl: './facilityasset-container.component.html',
  styleUrls: ['./facilityasset-container.component.scss']
})
export class FacilityAssetContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  facilityassets$: Observable<FacilityAssetDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("FacilityAsset");
    this.facilityassets$ = this.gatwayFacade.loadGateway("FacilityAsset");
    this.facilityassets$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteFacilityAsset(deletedValue: any) {
    this.gatwayFacade.remove("FacilityAsset", deletedValue);
    // this.store.dispatch(FacilityAssetStoreActions.removeFacilityAsset({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitFacilityAsset(formValue: any) {
    console.log("form value: ", formValue);
    formValue.FacilityAssets = formValue.FacilityAssets.reverse();
    event.preventDefault();
    const pullData = formValue.FacilityAssets;
    //const newPullData = formValue.FacilityAssetes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllFacilityAsset = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllFacilityAsset.push(pullData[i]);
    }
  }

// check if the addAllFacilityAsset array is not empty, then dispatch the data to the store
   if(addAllFacilityAsset.length !== 0) {
    this.gatwayFacade.add('FacilityAsset', addAllFacilityAsset);
    // this.store.dispatch(FacilityAssetStoreActions.addFacilityAsset({newFacilityAsset: addAllFacilityAsset}));

   }

// dispatch update data to the store
this.gatwayFacade.update('FacilityAsset', allUpdates, ['id']);
    // this.store.dispatch(FacilityAssetStoreActions.updateFacilityAsset({updateFacilityAsset: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}